/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_TIMESLOTS_REQUEST]: state => {
    state.loadingTimeslots = true;
    state.loadingTimeslotsSuccess = false;
    state.loadingTimeslotsFailed = false;
  },

  [types.GET_TIMESLOT_FAILURE]: (state, error) => {
    state.loadingTimeslots = false;
    state.loadingTimeslotsSuccess = false;
    state.loadingTimeslotsFailed = true;
    state.loadingCompaniesErrors = error.error;
  },

  [types.GET_TIMESLOT_SUCCESS]: (state, response) => {
    state.loadingTimeslots = false;
    state.loadingTimeslotsSuccess = true;
    state.loadingTimeslotsFailed = false;
    state.timeslots = response.data.results;
  },

  [types.SAVE_TIMESLOT_REQUEST]: state => {
    state.saveTimeslotRequest = true;
    state.saveTimeslotSuccess = false;
    state.saveTimeslotFailed = false;
  },

  [types.SAVE_TIMESLOT_SUCCESS]: state => {
    state.saveTimeslotRequest = false;
    state.saveTimeslotSuccess = true;
    state.saveTimeslotFailed = false;
  },

  [types.SAVE_TIMESLOT_FAILURE]: (state, error) => {
    state.saveTimeslotRequest = false;
    state.saveTimeslotSuccess = false;
    state.saveTimeslotFailed = true;
    state.saveTimeslotErrors = error.error;
  },

  [types.DELETE_TIMESLOT_REQUEST]: state => {
    state.deleteTimeslotsRequest = true;
    state.deleteTimeslotsSuccess = false;
    state.deleteTimeslotsFailed = false;
    state.deleteTimeslotErrors = null;
  },

  [types.DELETE_TIMESLOT_SUCCESS]: state => {
    state.deleteTimeslotsRequest = false;
    state.deleteTimeslotsSuccess = true;
    state.deleteTimeslotsFailed = false;
    state.deleteTimeslotErrors = null;
  },

  [types.DELETE_TIMESLOT_FAILURE]: (state, error) => {
    state.deleteTimeslotsRequest = false;
    state.deleteTimeslotsSuccess = false;
    state.deleteTimeslotsFailed = true;
    state.deleteTimeslotErrors = error.error;
  },

  [types.EDIT_TIMESLOT]: (state, timeslot) => {
    state.selectedTimeslot = timeslot;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/timeslots/mutations.js